import { Component, OnInit } from '@angular/core';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {
  isLoggedIn: boolean = false;
  isAuthenticated: boolean = false;
  userGroup: string = '';
  constructor(private authService: AuthService ) {
  

  }

  ngOnInit() {
    this.authService.authStatusChanged.subscribe((authenticated) => {
      this.isAuthenticated = authenticated;
      if (authenticated) {
        console.log('NavbarComponent authenticated!');
      } else {
        console.log('NavbarComponent not authenticated!');
      }
    });
    this.authService.userGroup.subscribe((userGroup) => {
      this.userGroup = userGroup;
      console.log('NavbarComponent userGroup: ',this.userGroup);
    });
    this.authService.isAuthenticated().subscribe((result:boolean) => {
      console.log('NavbarComponent isAuthenticated:', result);
      this.isAuthenticated = result;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/navbar/navbar.component.ts